export function intlDate() {
  const enFormatter = new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const enParts = enFormatter.formatToParts(new Date());
  const en = (t) => enParts.find(p => p.type === t)?.value || "";
  const date = `${en("weekday")}, ${en("day")} ${en("month")} ${en("year")}`;
  return  date;
}
